<template>
	<div class="my-table applicationPage">
		<!-- 面包屑组件 -->
		<div class="searchBox relative">
			<div class="fl">
				<!--  <div class="btnC activedBtn mr2" @click="dialogFormAddVisible = true">
          <img src="@/assets/picture/icon/newproject_icon.png" width="20"/>
          <span class="btn-txt">新建项目</span>
        </div> -->
			</div>
			<div class="fr rightBox">
				<div class="searchSubBox flex">
					<div class="flex searchSubBox w32">
						<span class="labelTxt">项目名称:</span>
						<el-input v-model="queryInfo.projectName" placeholder="请输入"></el-input>
					</div>
					<div @click="loadData" class="btnC activedBtn">
						<span class="btn-txt">查询</span>
					</div>
				</div>
			</div>
		</div>
		<!-- 面包屑 -->
		<el-card>
			<div class="table-header">
				<div class="left">
					<span>当前位置：项目管理/参与的项目</span>
				</div>
			</div>
			<el-row :gutter="20" class="cardContent">
				<el-col :span="8" class="cardBox" v-for="item in 16" :key="item">
					<div class="header">
						<span @click="goDetail">上海仁济医院东院脑神经科A-001</span>
						<div class="fr">
							<img src="@/assets/picture/icon/edit_icon.png" />
							<img src="@/assets/picture/icon/delete_S_icon.png" />
						</div>
					</div>
					<div class="contentBox">
						<p class="flex">
							<span class="labelTxt">管理员：</span>
							<span class="txt">zhangxiaobei0213（你本人）</span>
						</p>
						<p class="flex">
							<span class="labelTxt w19">参与者：</span>
							<span class="txt">chenxiaoliangliang00、liudaxie026、chenxiaoliangliang00、liudax
								ie026、zhangmingtao844、chenxiaoliangliang00</span>
						</p>
						<p>本项目由<span>您本人</span>于<span> 2020.12.20 13:45:36 </span>创建</p>
					</div>
				</el-col>
			</el-row>
		</el-card>
	</div>
</template>

<script>
import { formatDate } from "@/plugins/date.js";
import qs from "qs";
export default {
	data() {
		return {
			isIndeterminate: true,
			time: "",
			dialogFormEditRoleVisible: false, //修改角色弹窗
			dialogFormAddVisible: false, //添加用户弹窗
			dialogFormEditPasswordVisible: false, //修改密码弹窗
			fromData: {}, //分享参数
			options: [], //测试数据
			editRoleForm: {}, //修改角色参数
			addUserForm: {}, //添加用户参数
			editPasswordForm: {}, //修改密码参数
			//用于获取数据列表
			queryInfo: {
				id: "ff808081776afcf101776afdd2ae0000",
				me: 2,
				projectName: "",
			},
			dataList: [{}],
			total: 0,
		};
	},
	created() {
		this.loadData();
	},
	filters: {
		formatDate(time) {
			var date = new Date(time);
			return formatDate(date, "yyyy-MM-dd");
		},
	},
	methods: {
		// 数据加载(项目列表)
		async loadData() {
			const { data: res } = await this.$http.post(
				"/project/list?" + qs.stringify(this.queryInfo)
			);
			if (!res.success) {
				return this.$message.error(res.message);
			}
			this.dataList = res.result.data;
			this.total = res.result.data.length;
		},
		// 跳转到详情
		goDetail() {
			this.$router.push({ path: "/joinProjectDetail" });
		},
		// 修改角色
		handleEditRole() {
			this.dialogFormEditRoleVisible = true;
		},
		// 修改密码
		handleEditPassword() {
			this.dialogFormEditPasswordVisible = true;
		},
		// 删除
		handleDelete() {
			this.$confirm(
				'<p class="color666 fz14">确定要删除该用户吗</p><p class="color999 fz14">同时会删除该用户下的所有数据。</p>',
				"删除",
				{
					dangerouslyUseHTMLString: true,
					confirmButtonText: "取消",
					cancelButtonText: "确定",
					type: "warning",
					center: true,
				}
			)
				.then(() => {
					this.$message({
						type: "info",
						message: "已取消删除",
					});
				})
				.catch(() => {
					this.$message({
						type: "success",
						message: "删除成功!",
					});
				});
		},
		// 冻结
		handleFrozen() {
			this.$confirm(
				'<p class="color666 fz14">确定要冻结该用户吗</p><p class="color999 fz14">冻结后将无法登陆平台。</p>',
				"冻结",
				{
					dangerouslyUseHTMLString: true,
					confirmButtonText: "取消",
					cancelButtonText: "确定",
					type: "warning",
					center: true,
				}
			)
				.then(() => {
					this.$message({
						type: "info",
						message: "已取消删除",
					});
				})
				.catch(() => {
					this.$message({
						type: "success",
						message: "删除成功!",
					});
				});
		},
		// 搜索
		handleSearch() {
			this.queryInfo.pageNum = 1;
			this.queryInfo.pageSize = 10;
			this.loadData();
		},
		// 编辑/详情
		handleDetail(row, type) {
			this.$router.push({
				path: "/sceneRecordDetail",
				query: { type: type, id: row.id },
			});
		},
		// 页面切换
		handleCurrentChange(pageNum) {
			this.queryInfo.pageNum = pageNum;
			this.loadData();
		},
		handleSizeChange(pageSize) {
			this.queryInfo.pageSize = pageSize;
			this.loadData();
		},
	},
};
</script>

<style lang="less" scoped>
.applicationPage {
	.w32 {
		/deep/ .el-input,
		/deep/ .el-input__inner {
			width: 100% !important;
		}
	}
	.searchBox {
		/*width: 33.6rem !important;*/
		height: 3.2rem;
		.btnC {
			padding: 0.6rem 2.6rem;
		}
	}
	/deep/ .el-transfer__button:first-of-type {
		display: none;
	}
	/deep/ .el-button--primary {
		width: auto;
		height: auto;
		padding: 0;
		background: none;
	}
	/deep/ .el-button--primary.is-disabled {
		background: none;
		border: none;
	}
	/deep/ .el-button + .el-button {
		margin-left: 0 !important;
	}
	/deep/ .el-transfer__buttons {
		padding: 0;
	}
	.tips {
		font-size: 1.4rem;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #98b9ff;
		margin-top: -10px;
	}
	/deep/ .el-dialog {
		/deep/ .el-input,
		/deep/ .el-input__inner {
			width: 100% !important;
		}
		/deep/ .el-form-item:first-of-type,
		/deep/ .el-form-item:last-of-type {
			margin-bottom: 0;
		}
		/deep/ .el-dialog .el-dialog__body .el-select .el-input__inner,
		.el-dialog .el-dialog__body .el-input__inner,
		.el-dialog .el-dialog__body .el-input {
			border-radius: 8px;
		}
	}
	.cardContent {
		width: 100%;
		margin-top: 1.6rem;
		margin-left: 0 !important;
		.cardBox:nth-of-type(3n + 3) {
			margin-right: 0;
		}
		.cardBox {
			padding: 2rem 3rem 4.2rem 3rem !important;
			border: 1px solid #aaaaaa;
			box-shadow: 0rem 0rem 2rem 0rem rgba(202, 204, 204, 0.3);
			border-radius: 1rem;
			margin-bottom: 3rem;
			margin-right: 3rem;
			width: 31.5%;
			.header {
				border-bottom: 1px solid #cbcbcb;
				padding-bottom: 2rem;
				span {
					font-size: 1.4rem;
					font-weight: 400;
					color: #333333;
				}
				img {
					width: 1.6rem;
					height: 1.6rem;
					margin-right: 1.9rem;
					cursor: pointer;
				}
				img:last-of-type {
					margin-right: 0;
				}
			}
			.contentBox {
				padding-top: 2.9rem;
				p:first-of-type {
					margin-bottom: 2.5rem;
				}
				p:nth-of-type(2) {
					margin-bottom: 2rem;
				}
				p {
					font-size: 1.2rem;
					font-weight: 400;
					color: #999999;
					span {
						color: #666;
					}
				}
				.w19 {
					width: 19%;
				}
				.labelTxt {
					font-size: 1.4rem;
					margin-right: 1.4rem;
					font-weight: 400;
					color: #999999;
				}
				.txt {
					font-size: 1.4rem;
					font-weight: 400;
					color: #666666;
					line-height: 2.1rem;
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-line-clamp: 2;
					line-clamp: 2;
					-webkit-box-orient: vertical;
				}
			}
		}
	}
}
</style>
